import { combineReducers } from 'redux';
import {
    AuthenticatedUserContactsFetchSuccessActionType,
    AuthenticatedUserContactsFetchRequestActionType,
    AuthenticatedUserContactsFetchFailureActionType,
} from './authenticatedUserContactAction';
import { ActionType } from 'store/ActionType';
import { UserContact } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const userContacts = (
    state: Nullable<UserContact[]> = null,
    action: ActionType,
) => {
    if (action.type === AuthenticatedUserContactsFetchSuccessActionType) {
        return action.payload;
    }
    return state;
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case AuthenticatedUserContactsFetchRequestActionType: {
            return true;
        }
        case AuthenticatedUserContactsFetchFailureActionType:
        case AuthenticatedUserContactsFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    userContacts,
    isLoading,
});
